export default __webpack_public_path__ + "static/product2bg-4bcc301a8232c727b3e80e15563469a3.png";